<app-table-generator
    *ngIf="tableInput"
    [tableInput]="tableInput"
    (gridRef)="gridRef = $event"
    [widgetRef]="widgetRef"
    (selectionChanged)="selectedRow()"
></app-table-generator>
